var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[!_vm.user ? 'login' : '' ],attrs:{"id":"app"}},[(_vm.user)?_c('Menu'):_vm._e(),(_vm.validatingToken)?_c('Loading'):_c('Content')],1)}
var staticRenderFns = []

export { render, staticRenderFns }